import {PWMAT_RESOURCE} from './consts'

export const ReadPaper = [
  {
    name: '1. La和Mn掺杂钴尖晶石析氧催化剂用于质子交换膜电解 [Science]',
    url: 'https://mp.weixin.qq.com/s/OuaAYEkerhxGeVOqxdBcIQ',
  },
  {
    name: '2. 硅上In线的光致相变机理 [PRL]',
    url: 'https://mp.weixin.qq.com/s/0sEBloUVuBSrTpWZMVZIcw',
  },
  {
    name: '3. 实时的含时密度泛函理论 (rt-TDDFT)的算法进展及在超快动力学中的应用 [Wires Comput Mol Sci]',
    url: 'https://mp.weixin.qq.com/s/z1dueYPewceGSuaIEDe1Cg',
  },
  {
    name: '4. 理论与实验结合研究功能陶瓷光致伸缩效应 [Matter]',
    url: 'https://mp.weixin.qq.com/s/n1JSDZ37Z2gLbJAzRoj1Hg',
  },
  {
    name: '5. Science China Technological Sciences：计算电声耦合矩阵——理论简介、代码开发与初步应用 [Sci. China Technol. Sci]',
    url: 'https://mp.weixin.qq.com/s/O29YwGkc-L6TkPoLuuVDDQ',
  },
  {
    name: '6. 电解质环境中的锂枝晶形态演化模拟 [Advanced Energy Materials]',
    url: 'https://mp.weixin.qq.com/s/kapzIrPvL2AcGTUzdHgglg',
  },
  {
    name: '7. 实验与计算结合研究基于垂直架构的新型二维半导体/铁电多值存储器 [Advanced Materials]',
    url: 'https://mp.weixin.qq.com/s/5Yx7DkwHJ3u9EU65Zqg1FA',
  },
  {
    name: '8. 实验与理论计算结合研究Pb纳米晶体中的孪晶成核与传播过程 [Science Advances]',
    url: 'https://mp.weixin.qq.com/s/puL7Qgi_4Hcou_eYtk8NCQ',
  },
  {
    name: '9. 基于PWmat中的混合溶剂模型精确计算离子溶解自由能 [JCTC]',
    url: 'https://mp.weixin.qq.com/s/RalNE_Yu3Q8iKohS1bm1dw',
  },
  {
    name: '10. 电势驱动2D过渡金属二硫化物的半导体-金属相变 [Advanced Functional Materials]',
    url: 'https://mp.weixin.qq.com/s/hxLKDAJ0XFiABps2Lt2ngg',
  },
{
  name: '11. 酸性OER机理探究：Operando直接观察Ca2-xIrO4上的稳定中间体 [Nano Lett.]',
  url: 'https://mp.weixin.qq.com/s/q_NT2cDp9OhKR5UWPqYwlg',
},
{
  name: '12. 面向NV色心的氟终端结构金刚石表面第一性原理计算 [Carbon]',
  url: 'https://mp.weixin.qq.com/s/fzuDc-IkQwCiceIVMZ1FzA',
},
{
  name: '13. 统一光诱导二氧化钒相变过程中的有序和无序动力学 [PNAS]',
  url: 'https://mp.weixin.qq.com/s/D85ZWf19QPlQCmlXfnKdxw',
},
{
  name: '14. 激光诱导半导体材料退火过程中非热融化机理的研究 [Science Advances]',
  url: 'https://mp.weixin.qq.com/s/2K6oOkWv7sEjo0i8zUSelw',
},
{
  name: '15. 带电缺陷计算中镜像电荷相互作用修正 [Physical Review B]',
  url: 'https://mp.weixin.qq.com/s/n2dH-lwj2-YhMDnvuou0iA',
},
{
  name: '16. TDDFT揭示电子诱导的半导体/氧化物界面缺陷产生机制 [PRB]',
  url: 'https://mp.weixin.qq.com/s/5F623D5tgHdewio-GtyFrA',
},
{
  name: '17. 打破MXenes电催化CO2还原中的线性关系以实现高效制CH4 [CEJ]',
  url: 'https://mp.weixin.qq.com/s/kGGuTX40Z3nVYfkX956RpA',
},
{
  name: '18. PtS2/GaSe范德华异质结在太阳能转化中的应用 [PCCP]',
  url: 'https://mp.weixin.qq.com/s/SdizcsMTMdpM5zU6n1Bjfg',
},
{
  name: '19. 层状LiNiO₂中的缺陷调制Jahn-Teller效应 [Science China Materials]',
  url: 'https://mp.weixin.qq.com/s/CQtQe9qnDQWt_vxVZTEXog',
},
{
  name: '20. 超薄h-BN/Bi2MoO6异质结构对四环素的光催化协同降解 [Journal of Colloid and Interface Science]',
  url: 'https://mp.weixin.qq.com/s/...',
},
// Continue from the previous entries...
{
  name: '21. DFT研究II-VI族离子性半导体中的非辐射复合过程 [Physical Review Applied]',
  url: 'https://mp.weixin.qq.com/s/MwibV1OrqHRtvWs64bk_tw',
},
{
  name: '22. PWmat在计算半导体点缺陷的量子效应方面取得重要成果 [ADVANCE OPTICAL MATERIALS]',
  url: 'https://mp.weixin.qq.com/s/jIJUeo9TBCLEGmSmraru7w',
},
{
  name: '23. fixed-potential 方法研究电极电势对单原子催化剂OER反应的影响 [Journal of Catalysis]',
  url: 'https://mp.weixin.qq.com/s/Y7Ga776KQbzzL8VqbCqMXA',
},
{
  name: '24. 螺旋扭转下的三维摩尔条纹超晶格结构 [PRB]',
  url: 'https://mp.weixin.qq.com/s/oxHogZMv_FJl_OKMb4V-yA',
},
{
  name: '25. 基于III族氮化物材料中的点缺陷的单光子发射源 [ACS Applied Materials & Interfaces]',
  url: 'https://mp.weixin.qq.com/s/ebFmVhfRFvGXyqp1bH7NVw',
},
{
  name: '26. 碳掺杂的六方氮化硼纳米带作为高效的非金属电化学合成氨催化剂 [Chemical Engineering Journal]',
  url: 'https://mp.weixin.qq.com/s/8S67hrIGHarQxzSHXQOpiQ',
},
{
  name: '27. TDDFT研究光场调控的超快结构相变：热载流子冷却的重要作用 [npj Computational Materials]',
  url: 'https://mp.weixin.qq.com/s/oJ_0CRbV34By4Mz_zi-1zA',
},
{
  name: '28. PWmat的solvent model模块关于Li-S电池的成果 [Advance Energy Materials]',
  url: 'https://mp.weixin.qq.com/s/gAlAGkS4X9OcBAw6a_fn4w',
},
{
  name: '29. CPM研究具有强局域态的可变换不对称莫尔条纹 [J. Phys. Chem. Lett.]',
  url: 'https://mp.weixin.qq.com/s/owt7CzyBokqGe23zio1tVA',
},
{
  name: '30. 实验与理论结合研究高压下钴酸锂不稳定性的结构起源 [Nature Nanotechnology]',
  url: 'https://mp.weixin.qq.com/s/oB166VSTg3n2imz8hPP70g',
},
// Continue from the previous entries...
{
  name: '31. MoS2中缺陷态间声子辅助跳跃的多尺度模拟 [J. Phys. Chem. Lett.]',
  url: 'https://mp.weixin.qq.com/s/eepRLYErQEyOhMcIeCr2RQ',
},
{
  name: '32. 锰掺杂对量子点敏化太阳能电池中电子注入过程的影响 [PCCP]',
  url: 'https://mp.weixin.qq.com/s/eOTjwB6ilVWj7EKcD6_t0Q',
},
{
  name: '33. PWmat适用于异质结电子结构计算的HSE方法发表重要成果 [PCCP]',
  url: 'https://mp.weixin.qq.com/s/htADAD1FAxBAFPDiOy6Gfg',
},
{
  name: '34. PWmat的TDDFT模块发表重要研究成果 [PCCP]',
  url: 'https://mp.weixin.qq.com/s/fFo-At42ci9aGB-cGmIxKw',
},
{
  name: '35. 非简谐近似马库斯电荷转移理论揭示MoS₂场效应晶体管中缺陷引起的电荷俘获/退俘获和迟滞现象 [ACS Applied Materials & Interfaces]',
  url: 'https://mp.weixin.qq.com/s/3X6FPjmS78AqxbdiGuyqOg',
},
{
  name: '36. 揭示乙炔桥联的Donor−π−Acceptor共价三嗪框架中用于增强光氧化还原催化的电荷动力学 [ACS Catal]',
  url: 'https://mp.weixin.qq.com/s/BKSm_I3ZXknIcWMP0v0bVA',
},
{
  name: '37. 分子动力学模拟揭示杂化钙钛矿材料的电子束辐照损伤机制 [Appl. Phys. Lett]',
  url: 'https://mp.weixin.qq.com/s/ix-kYeYrfwgf_h2SN3Pxpw',
},
{
  name: '38. 半导体中的杂质扩散诱导其缺陷态上电子激发的动力学过程 [Physical Review B]',
  url: 'https://mp.weixin.qq.com/s/XGlpe6zG8dmD_rebllli8g',
},
{
  name: '39. 电声耦合诱导的Floquet电子结构 [npj Quantum Mater]',
  url: 'https://mp.weixin.qq.com/s/JIACH-ZGtyYtYGv1yD2BbQ',
},
{
  name: '40. 缺陷石墨烯表面单铁原子催化氧还原反应 [J. Phys. Chem]',
  url: 'https://mp.weixin.qq.com/s/tL7xdQRh3CzrVnLX-HTDaw',
},
{
  name: '41. 二维导电微孔配位聚合物与非晶Li-S层堆叠实现固态三维锂硫电池设计 [Chemistry of Materials]',
  url: 'https://mp.weixin.qq.com/s/RL0euSvwgs2JUGZmPidt5A',
},
{
  name: '42. 多尺度模拟Si3N4 3D NAND闪存侧向电荷损失 [J. Phys. D]',
  url: 'https://mp.weixin.qq.com/s/2Ql5h_bbU7OeXxhJaLMefw',
},
{
  name: '43. 实验与理论计算结合对氮化物半导体掺杂研究取得重要进展 [PRL]',
  url: 'https://mp.weixin.qq.com/s/KX1eDo1j9SRudIcFEMQtIw',
},
{
  name: '44. 揭示多功能嵌段共聚物粘合剂在锂硫电池中的工作机理 [Journal of Energy Chemistry]',
  url: 'https://mp.weixin.qq.com/s/GdOqjQxk3Cfgz_jfrUjdmQ',
},
{
  name: '45. 实验与理论计算结合研究铜金属表面钝化膜中缺陷类型以及缺陷浓度影响 [Journal of Electroanalytical Chemistry]',
  url: 'https://mp.weixin.qq.com/s/NMn6UjLqWgoqVK0T133nIg',
},
{
  name: '46. 实验与理论计算结合在高性能钠离子电池负极材料研究方面取得进展 [Nano Energy]',
  url: 'https://mp.weixin.qq.com/s/8K8ta3gVDgTmHHkb5UA0ZA',
},

]


